import type { UpdateUserInfoRequest } from "../../domain/types/user";
import type { LandingUserInfoResponse } from "../../domain/types/shared";
import { LandingUserInfoResponseSchema } from "../../domain/types/shared";
import type { UserRepository } from "../../domain/repositories/user-repository";
import { userApiService } from "../api/user-api-service";

export class UserRepositoryImpl implements UserRepository {
  async getUserInfo(): Promise<LandingUserInfoResponse> {
    const response = await userApiService.getUserInfo();

    if (response.data) {
      return LandingUserInfoResponseSchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "유저 정보 가져오기 실패.");
  }

  async updateUserInfo(request: UpdateUserInfoRequest): Promise<LandingUserInfoResponse> {
    const response = await userApiService.updateUserInfo(request);

    if (response.data) {
      return LandingUserInfoResponseSchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "유저 정보 수정 실패.");
  }
}